/** Percentual (0 a 100) da quantidade atual em relação à meta. */
export function getGoalValue(quantity: string, goalValue: string) {
  const goal = Number(goalValue ?? 0);
  let value = (Number(quantity) / goal) * 100;

  if (value >= 100) value = 100;
  if (value < 0 || Number(quantity) === 0 || goal === 0) value = 0;

  return value;
}
